<h2 app-landing-page-title i18n="@@landingPage.assets.title">Assets</h2>

<mat-card>
  <mat-card-header>
    <mat-card-title>
      <persistent-simple-text-section-entity section="landingPage.assets.title">
      </persistent-simple-text-section-entity>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <app-pending-transfer-asset-approve [onInitSearchDelay]="true"></app-pending-transfer-asset-approve>
    <persistent-rich-text-section-entity section="landingPage.assets.text"></persistent-rich-text-section-entity>
  </mat-card-content>
</mat-card>